import { Pipe, PipeTransform } from '@angular/core';
import { format } from 'date-fns/format';

import { LongDateFormatToken, getLongDateFormat } from '@optical/utils';

@Pipe({
  name: 'date',
})
export class DatePipe implements PipeTransform {
  transform(value: Date | null | undefined, dateFormat = 'LL'): string | null {
    if (!value) return null;

    const pattern = isLongDateFormatToken(dateFormat) ? getLongDateFormat(dateFormat) : dateFormat;

    return format(value, pattern);
  }
}

function isLongDateFormatToken(dateFormat: string): dateFormat is LongDateFormatToken {
  return (
    dateFormat === 'L' ||
    dateFormat === 'LL' ||
    dateFormat === 'll' ||
    dateFormat === 'LT' ||
    dateFormat === 'LTS'
  );
}
